import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import getFormattedHour from 'presentation/modules/booking/shared/utils/getFormattedHour';
import {useBeneficiaryCard} from 'presentation/hooks/useBeneficiaryCard';
import {getAddressforMaps} from 'presentation/utils';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';

export function useOdontoReviewBookingNew() {
	const bookingData = useBookingStore(state => state.bookingData);
	const {beneficiaryCardPlanData} = useBeneficiaryCard();

	const address = getAddressforMaps(bookingData.unitAddress);
	const formattedAddress = address.formattedAddress;
	const addressForMaps = address.addressForMaps || '';

	const hour = getFormattedHour(bookingData.hourAt, FlowEnum.ODONTO);

	const handleOpenGoogleMaps = () => openGoogleMaps(addressForMaps);

	return {
		beneficiaryName: beneficiaryCardPlanData.userName,
		planName: beneficiaryCardPlanData.planName,
		providerName: bookingData.professionalName,
		specialtyName: bookingData.specialtyName,
		clinicName: bookingData.unitName,
		date: bookingData.dateAt,
		hour,
		formattedAddress,
		addressForMaps,
		handleOpenGoogleMaps,
	};
}
